import RenderHTML from '../ui-components/RenderHTML'

const ASSETS = {
  quoteMark: '/images/new-elite/testimonials/testimonial_quote.svg',
  cornerAccent: '/images/new-elite/testimonials/union.svg'
} as const

export type EliteTestimonialItem = {
  id?: string
  quote: string
  name: string
}

export type EliteTestimonialsTitle = {
  line1: string
  line2?: string
}

type EliteTestimonialsCarouselProps = {
  title: EliteTestimonialsTitle
  testimonials: EliteTestimonialItem[]
  className?: string
}

export function EliteTestimonialsCarousel({
  title,
  testimonials,
  className = 'mt-20'
}: EliteTestimonialsCarouselProps) {
  if (!testimonials.length) return null

  return (
    <section className={className}>
      <div className='flex flex-col gap-6'>
        <div className='flex flex-col px-1'>
          <p className='text-lg font-medium leading-[1.5] text-[#232323]'>{title.line1}</p>
          {title.line2 ? (
            <p className='text-[13px] font-normal leading-[1.4] text-[#6A6E6E]'>{title.line2}</p>
          ) : null}
        </div>

        <div className='-mx-5'>
          <ul className='flex list-none snap-x snap-mandatory gap-3 overflow-x-auto overflow-y-hidden px-5 pb-1 no-scrollbar [scroll-padding-inline:20px]'>
            {testimonials.map((item) => (
              <EliteTestimonialCarouselCard
                key={item.id ?? item.name}
                testimonial={item}
              />
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export function EliteTestimonialCarouselCard({ testimonial }: { testimonial: EliteTestimonialItem }) {
  return (
    <li className='relative w-[264px] shrink-0 snap-start'>
      <figure className='relative m-0 rounded-2xl border border-[#FAE5DF] bg-white px-6 py-8 shadow-[inset_3px_0px_0px_0px_#FFEBCF]'>
        <div className='relative z-0 flex h-[282px] flex-col justify-between'>
          <div className='flex flex-col gap-5'>
            <img alt='' className='h-[27px] w-9 shrink-0 object-contain' src={ASSETS.quoteMark} />
            <blockquote className='m-0 text-base leading-[1.4] text-[#232323]'>
              <RenderHTML innerHTMLText={testimonial.quote} />
            </blockquote>
          </div>
          <figcaption className='text-[13px] font-normal leading-[1.5] text-[#8E9393]'>
            {testimonial.name}
          </figcaption>
        </div>
        <div className='absolute bottom-[-5px] right-[-8px] z-[1] bg-white p-2'>
          <img alt='' className='pointer-events-none size-6 object-contain' src={ASSETS.cornerAccent} />
        </div>
      </figure>
    </li>
  )
}
